<div class="card-product -title">
  <div *ngIf="largetitle" class="-text-caption -fontDisplayThin">{{largetitle}}</div>
  <h3>{{title}}</h3>
</div>
<ng-content></ng-content>
